"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NavigationGroupType = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

var _excluded = ["Wrapper", "item", "isSingleItem", "handleClick", "className", "createLinkElement"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var NavigationGroupItemType = _propTypes.default.shape({
  label: _propTypes.default.string.isRequired,
  url: _propTypes.default.string.isRequired
});

var NavigationGroupType = _propTypes.default.shape({
  title: _propTypes.default.string.isRequired,
  items: _propTypes.default.arrayOf(NavigationGroupItemType).isRequired
});

exports.NavigationGroupType = NavigationGroupType;

var NavigationGroupItem = function NavigationGroupItem(_ref) {
  var Wrapper = _ref.Wrapper,
      item = _ref.item,
      isSingleItem = _ref.isSingleItem,
      handleClick = _ref.handleClick,
      className = _ref.className,
      createLinkElement = _ref.createLinkElement,
      restProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var linkProps = _objectSpread({}, restProps);

  delete linkProps.children;
  delete linkProps.child;
  var element = createLinkElement ? createLinkElement(item) : /*#__PURE__*/_react.default.createElement(Wrapper, linkProps);

  var onClick = function onClick() {
    handleClick === null || handleClick === void 0 ? void 0 : handleClick();

    if (element.props.onClick) {
      element.props.onClick();
    }

    if (linkProps.onClick) {
      linkProps.onClick();
    }
  };

  return /*#__PURE__*/_react.default.cloneElement(element, {
    key: item.url,
    className: (0, _classnames.default)(isSingleItem ? _indexModule.default.title : _indexModule.default.link, (0, _defineProperty2.default)({}, _indexModule.default.singleItem, isSingleItem)),
    onClick: onClick
  }, item.label);
};

NavigationGroupItem.defaultProps = {
  isSingleItem: false,
  Wrapper: 'a'
};
NavigationGroupItem.propTypes = {
  item: NavigationGroupItemType.isRequired,
  isSingleItem: _propTypes.default.bool,
  Wrapper: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string]).isRequired,
  handleClick: _propTypes.default.func,
  className: _propTypes.default.string,
  createLinkElement: _propTypes.default.func
};
var _default = NavigationGroupItem;
exports.default = _default;